import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {PreComponent} from './pre.component';

@NgModule({
  imports: [CommonModule, RouterModule],
  declarations: [PreComponent],
  exports: [PreComponent],
})
export class PreModule {}



// WEBPACK FOOTER //
// ./src/app/auth/register/pre/pre.module.ts